import React from 'react';
import * as cls from './footer-ctas.module.css';
import { ROUTES_PATHS } from '../../../../constants';
import { Section } from '../../../../ui/components/section';
import { Typography } from '../../../../ui/components/typography';
import { Link } from 'react-router-dom';
import { Button } from '../../../../ui/components/button';

export const FooterCTAs = () => {
  return (
    <Section backgroundContrast classNameRoot={cls.section}>
      <Typography as="h1" tag="h3">
        Bring Appliance-Level Insights to Your Customers
      </Typography>
      <Typography>
        Deploy Voltaware AI disaggregation to deliver clear bill breakdowns,
        reduce high-bill queries, and increase digital engagement. Integrate via
        APIs, dashboards, or white-label experiences.
      </Typography>
      <Link to={ROUTES_PATHS.REQUEST_A_DEMO}>
        <Button>Request Demo</Button>
      </Link>
    </Section>
  );
};
